import {
  QuoteStatusDescription,
  QuoteStatusWaitingDescriptionByPaymentMethod,
} from "types/enums";

import * as S from "../../styles";

interface TimeLineProps {
  step: number;
  quoteStatus: number;
  paymentMethod?: number;
  isPendingItems?: boolean;
}

const stepIcons: Record<number, string> = {
  1: "uil-bill",
  2: "uil-hourglass",
  3: "uil-hourglass",
  4: "uil-dollar-sign-alt",
  5: "uil-calender",
  6: "uil-check-circle",
};

const TimeLineStep = ({ step, quoteStatus, paymentMethod, isPendingItems }: TimeLineProps) => {
  const state =
    quoteStatus > step ? "done" : quoteStatus === step ? "active" : "upcoming";

  const label = paymentMethod
    ? QuoteStatusWaitingDescriptionByPaymentMethod[paymentMethod]
    : QuoteStatusDescription[step];

  return (
    <S.StepItem
      $state={state}
      aria-current={state === "active" ? "step" : undefined}
    >
      <S.StepDot $state={state} aria-hidden="true">
        {state === "done" ? (
          <i className="uil uil-check" />
        ) : (
          <i className={`uil ${stepIcons[step] ?? "uil-circle"}`} />
        )}
        {isPendingItems && state === "active" && (
          <S.StepBadge aria-label="Pendências encontradas" />
        )}
      </S.StepDot>

      <S.StepLabel $state={state}>{label}</S.StepLabel>
    </S.StepItem>
  );
};

export default TimeLineStep;
